import React, { useEffect, useRef, useState } from "react";
import "./Login.css";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { loginUser } from "../../Redux/Slice/authSlice";
import { validateEmailFomat } from "../../utils/helper";
import AuthServices from "../../Services/AuthServices";

const LoginRegister = ({ setModal }) => {
  const isFirstRender = useRef(true);

  const { loading, error, token, user } = useSelector((state) => state.auth);
  const [form, setForm] = useState(false);

  const [registrationFormData, setRegistrationFormData] = useState({
    name: "",
    email: "",
    password: "",
    otp: "",
    mobileNo: "",
  });

  const [loginFormData, setLoginFormData] = useState({
    email: "",
    password: "",
  });

  const dispatch = useDispatch();
  const [loginAttempt, setLoginAttempt] = useState(0);

  //Login Form Submit
  const handleLogin = (e) => {
    e.preventDefault();
    console.log("RRR17", loginFormData);
    if (!loginFormData.email) return toast.error("Enter email");
    if (!loginFormData.password) return toast.error("Enter password");
    setLoginAttempt(loginAttempt + 1);
    dispatch(loginUser(loginFormData));
    console.log("HGGF39", token);

    // setLoginFormData({
    //   email: "",
    //   password: ""
    // })
    //error && toast.error(error)
  };

  useEffect(() => {
    token && setModal(false);
  }, [token]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (error) {
      toast.error(error);
    }

    if (loginAttempt > 0 && !error) {
      setModal(false);
    }
  }, [error]);

  const [sendingOTP, setSendingOTP] = useState(false);
  const [sentOTP, setSentOTP] = useState(false);

  const sendOTP = async (e) => {
    e.preventDefault();
    if (!validateEmailFomat(registrationFormData?.email))
      return toast.error(
        <>
          <p>
            Enter your active email address to get the <strong>OTP</strong>
          </p>
        </>
      );

    const formData = {
      name: registrationFormData.name,
      email: registrationFormData.email,
      mobileNo: registrationFormData?.mobileNo,
      //password:"p@ss123"
    };
    console.log("YTR64", formData);
    try {
      setSendingOTP(true);
      const res = await AuthServices.sendOTPtoEmail(formData);
      if (res && res?.status) {
        toast.success(
          <>
            OTP sent successfully.
            <br />
            Please check your inbox
          </>
        );
        setSentOTP(true);
      }
    } catch (error) {
      console.error("Error in register", error);
      toast.error(error?.message);
    } finally {
      setSendingOTP(false);
    }
  };

  const handleRegistration = async (e) => {
    e.preventDefault();
    if (!registrationFormData.otp)
      return toast.error(
        <>
          <p>
            Enter the <strong>OTP</strong> you received in your email.
          </p>
        </>
      );
    let formData = {
      email: registrationFormData.email,
      otp: registrationFormData.otp,
    };
    try {
      const res = await AuthServices.verifyOTP(formData);
      if (res && res?.status) {
        formData = {
          name: registrationFormData.name,
          email: registrationFormData.email,
          password: registrationFormData.password,
        };
        const res = await AuthServices.registerAccount(formData);
        if (res && res?.status) {
          toast.success("Registration Successfull");
          setModal(false);
        }
      } else {
        toast.error("Invalid OTP");
      }
    } catch (error) {
      console.error("Error validation otp:", error);
    }
  };

  return (
    <>
      <div
        className="login_modal_wrapper"
        //onClick={(() => setModal(false))}
      ></div>

      <div className="container5685">
        <button className="cross-btn" onClick={() => setModal(false)}>
          <i className="fas fa-times"></i>
        </button>
        <div className="box5252">
          <div className="toggle">
            <button
              className={!form ? "toggle-btn active" : "toggle-btn"}
              id="login-btn"
              onClick={() => {
                setForm(false);
              }}
            >
              Login
            </button>
            <button
              onClick={() => {
                setForm(true);
              }}
              className={form ? "toggle-btn active" : "toggle-btn"}
              id="register-btn"
            >
              Register
            </button>
          </div>
          <div className="form-wrapper">
            {!form && (
              <form id="login-form">
                <input
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={loginFormData?.email || ""}
                  onChange={(e) => {
                    setLoginFormData({
                      ...loginFormData,
                      email: e.target.value,
                    });
                  }}
                  required
                />
                <input
                  type="password"
                  placeholder="Password"
                  name="password"
                  value={loginFormData?.password || ""}
                  onChange={(e) => {
                    setLoginFormData({
                      ...loginFormData,
                      password: e.target.value,
                    });
                  }}
                  required
                />
                <button
                  type="submit"
                  className="submit-btn"
                  onClick={(e) => handleLogin(e)}
                >
                  Login
                </button>
              </form>
            )}
            {form && (
              <form id="register-form">
                <input
                  type="text"
                  placeholder="Name"
                  name="name"
                  value={registrationFormData?.name || ""}
                  onChange={(e) => {
                    setRegistrationFormData({
                      ...registrationFormData,
                      name: e.target.value,
                    });
                  }}
                />

                <input
                  type="text"
                  placeholder="Mobile Number"
                  name="name"
                  value={registrationFormData?.mobileNo || ""}
                  onChange={(e) => {
                    setRegistrationFormData({
                      ...registrationFormData,
                      mobileNo: Number(e.target.value),
                    });
                  }}
                />

                {/* <input type="email" placeholder="Email" name="email" value={registrationFormData?.email || ""} onChange={(e) => { setRegistrationFormData({ ...registrationFormData, email: e.target.value }) }} required /> */}

                {/* <div className="flex-input">
                <input type="text" placeholder="Type something..." />
                <button >Go</button>
              </div> */}
                <div className="input-wrapper">
                  <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={registrationFormData?.email || ""}
                    onChange={(e) => {
                      setRegistrationFormData({
                        ...registrationFormData,
                        email: e.target.value,
                      });
                    }}
                    required
                  />
                  <button
                    type="button"
                    className="input-button"
                    onClick={(e) => {
                      sendOTP(e);
                    }}
                  >
                    {sendingOTP ? "Sending..." : "Send OTP"}
                  </button>
                </div>

                <input
                  type="text"
                  placeholder="OTP"
                  name="otp"
                  style={{
                    display: sentOTP ? "block" : "none",
                  }}
                  value={registrationFormData?.otp || ""}
                  onChange={(e) => {
                    setRegistrationFormData({
                      ...registrationFormData,
                      otp: e.target.value,
                    });
                  }}
                  required
                />

                <input
                  type="password"
                  placeholder="Password"
                  name="password"
                  value={registrationFormData?.password || ""}
                  onChange={(e) => {
                    setRegistrationFormData({
                      ...registrationFormData,
                      password: e.target.value,
                    });
                  }}
                  required
                />
                <button
                  type="submit"
                  className="submit-btn"
                  // disabled={true}
                  onClick={(e) => handleRegistration(e)}
                >
                  Register
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginRegister;
